import { observable } from 'mobx';
import { createTransformer } from 'mobx-utils';

import CacheStore from 'bz-utilities/modules/stores/cached-map-store';

import type { NestedLookup } from 'tm3-core/api.dtos';

export interface INestedLookupItem {
  alternates: object;
  description: string;
  position: number;
}

class NestedLookupStore extends CacheStore<NestedLookup> {
  constructor() {
    super('nestedLookups');
  }

  public readonly GetNestedLookups = createTransformer((lookupId: string) => {
    return this.getById(lookupId.toLowerCase());
  });

  public readonly GetParsedNestedLookup = createTransformer((lookupId: string) => {
    try {
      const res = this.GetNestedLookups(lookupId);
      const list = res?.value ? JSON.parse(res?.value) : {};

      return Object.values(observable(list?.main ?? {})) as INestedLookupItem[];
    } catch (e) {
      console.error('[NestedLookupStore.GetParsedNestedLookup] -', e);
      return [];
    }
  });
}

export default NestedLookupStore;
